<div class="img-container">
    <img #image [src]="imageSource" crossorigin>
</div>
<app-button-set align="right">
    <app-button (click)="onCrop()" label="Proceed"></app-button>
</app-button-set>